/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const payment = {
  paymentForm: {
    payment: 'Pagamento',
    choosePagamentoMethod: 'Escolha um método de pagamento',
    paymentType: 'Tipo de Pagamento',
    accountHolderName: {
      label: 'Nome do titular da conta',
      placeholder: 'Nome do titular da conta',
    },
    cardNumber: 'Número do cartão',
    expirationDate: 'Data de validade',
    securityCode: 'Código de segurança (CVV)',
    securityCodeTitle: 'Valor de verificação do cartão',
    saveAsDefault: 'Salvar como padrão',
    setAsDefault: 'Definir como método de pagamento padrão',
    billingAddress: 'Endereço de cobrança',
    sameAsDeliveryAddress: 'Igual ao endereço de entrega',
    billingAddressSameAsShipping:
      'O endereço de cobrança é o mesmo que o endereço de entrega',
    selectOne: 'Selecione um...',
    monthMask: 'MILÍMETRO',
    yearMask: 'AAAAA',
    expirationYear: 'Ano de caducidade {{ selected }}',
    expirationMonth: 'Mês de validade {{ selected }}',
    useThisPagamento: 'Use este pagamento',
    addNewPagamento: 'Adicionar novo pagamento',
    paymentAddedSuccessfully: 'O novo pagamento foi adicionado com sucesso',
    changePagamento: 'Cambiar Pagamento',
  },
  paymentMethods: {
    paymentMethods: 'Métodos de pagamento',
    paymentMethodSelecionado: 'Método de pagamento selecionado',
    newPaymentMethodsAreAddedDuringCheckout:
      'Novos métodos de pagamento são adicionados durante o processo de finalização da compra.',
    invalidField: 'CampoInválido: {{ field }}',
  },
  paymentCard: {
    deleteConfirmation: 'Tem certeza de que deseja excluir este método de pagamento?',
    setAsDefault: 'Definir como padrão',
    expires: 'Expires: {{ month }}/{{ year }}',
    defaultPagamentoMethod: '✓ PADRÃO',
    defaultPagamentoLabel: 'Forma de pagamento padrão',
    additionalPagamentoLabel: 'Método de pagamento adicional {{ number }}',
    selected: 'Selecionado',
    deletePagamentoSuccess: 'O método de pagamento foi removido com sucesso',
  },
  paymentTypes: {
    title: 'Método Pagamento',
    paymentType_CARD: 'Cartão de crédito',
    paymentType_ACCOUNT: 'Conta',
  },
  paymentMessages: {
    setAsDefaultSuccessfully: 'O novo pagamento foi definido com sucesso como padrão',
  },
};
